export default __webpack_public_path__ + "static/media/3d-business-man-and-woman-working-at-the-table.abe112f7.png";